import React from "react";
import { $t } from '@/modules/i18n';

class Contact extends React.Component {
  render() {
    const msg = this.props.Message;
    return (
      <section id="contact">
        <div className="container text-center">
          <div className="title-block">
            <h3>{$t(msg.contactDesc01)}</h3>
            <a href={"mailto:" + msg.contactEmail} className="btn btn-primary" style={{margin: "30px 0"}}>{$t(msg.contactBtn)}</a>
            <div className="note" style={{ textAlign: "left" }}>
              <ul>
                <li>{$t(msg.contactDesc02)} <a href={"mailto:" + msg.contactEmail}>{msg.contactEmail}</a></li>
                <li>{$t(msg.contactDesc03)}</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
export default Contact;